import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Restricted from "src/app/Restricted";
import PATHS, { url } from "src/consts/urlPaths";

type SummaryLinkProps = {
  children?: ReactNode;
  item: { name?: string };
  className?: string;
};

const SummaryLink = ({ children, item, className }: SummaryLinkProps) => (
  <Restricted>
    <Link
      id="summary-nav-link"
      to={url(PATHS.INSIGHTS)}
      aria-label={item.name}
      className={className}
    >
      {children}
    </Link>
  </Restricted>
);

export default SummaryLink;
